<template>
    <div class="form-wrapper">
        <Select
            class="form-type-select"
            :config="{ initLabel: data.formName || '' }"
            :initValue="initFormId"
            :topOrBottom="86"
            :options="fromTypeOption"
            @menuClick="formSelected"
        >
            <Search :placeholder="formSelectedLabel" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
        </Select>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";

import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "Form",
    props: ["data"],
    components: {
        Select,
        Search
    },
    computed: {
        initFormId() {
            return this.data.formId || "def";
        },
        fromTypeOption() {
            let formTypeOption = [...this.getStorePorp("formTypeDatas")];

            // 添加默认状态
            formTypeOption.unshift({
                label: this.$t("zhiji.answer.selectFormType"),
                value: "def"
            });
            return formTypeOption;
        },
        formSelectedLabel() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchByFormName(searchField);
        }, 500);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        formSelected(data) {
            this.commitStore({
                formId: data.value + "",
                formName: data.label
            });
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchByFormName(data) {
            this.$store.dispatch("zhiji/getFormTypeList", {
                page: 1,
                size: 10,
                status: 1, // 只关联正常状态的表单
                keyword: data.value
            });
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: widget
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
    position: relative;
    width: 350px;
    padding: 14px;
    border-radius: 8px;
    background: #f2f7fb;
    .form-type-select {
        width: 100%;
        color: #9b9ba3;
        background: #fff;
        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
            z-index: 1;
        }
    }
}
</style>
